export default function ResumeEdit() {
  return (
    <div className="app-page">
      <h1 className="app-page-title">简历修改</h1>
      <div className="app-page-card">在此接入简历编辑与优化能力。</div>
    </div>
  )
}
